import { render, staticRenderFns } from "./MetadadosCampoDinamicoBoolean.vue?vue&type=template&id=6f11935a"
import script from "./MetadadosCampoDinamicoBoolean.vue?vue&type=script&lang=js"
export * from "./MetadadosCampoDinamicoBoolean.vue?vue&type=script&lang=js"
import style0 from "./MetadadosCampoDinamicoBoolean.vue?vue&type=style&index=0&id=6f11935a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports